import { Routes, Route } from "react-router-dom";
import { PublicLayout } from "../layout/publicLayout";
import { PrivateLayout } from "../layout/privateLayout";
import { RequiereAuth } from "../hooks/RequiereAuth";
import { PrivadaRouter } from "./PrivateRoutes";
import { LibreRouter } from "./LibreRouter";
import { AuthLayout } from "../layout/authLayout";
import { LoginScreen } from "../pages/public/loginScreen";

export const IndexRoutes = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route element={<PrivateLayout />}>
          <Route
            path="/home/*"
            element={
              <RequiereAuth perfil="">
                <PrivadaRouter />
              </RequiereAuth>
            }
          ></Route>
        </Route>
      </Route>
      <Route element={<PublicLayout />}>
        <Route path="/auth/*" element={<LibreRouter />}></Route>
      </Route>
      <Route path="/*" element={<LoginScreen />}></Route>
    </Routes>
  );
};
